export default "/images/web-button-center-cropped.png?f3287626bae8ff0e5ecd78cd1ea19c65";